type WindowWithQuickFetchErrors = Window &
  typeof globalThis & {
    hubspotQuickFetchErrors?: Error[];
  };

export const clearQuickFetchErrorsFromWindow = () => {
  delete (window as WindowWithQuickFetchErrors).hubspotQuickFetchErrors;
};

export const getQuickFetchErrorsFromWindow = () =>
  (window as WindowWithQuickFetchErrors).hubspotQuickFetchErrors || [];

export const setQuickFetchErrorOnWindow = (error: Error) => {
  (window as WindowWithQuickFetchErrors).hubspotQuickFetchErrors = [
    ...getQuickFetchErrorsFromWindow(),
    error,
  ];
};
